var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-item-footer" }, [
    _c(
      "div",
      { staticClass: "event-item-icon-component no-margin-left-right row" },
      [
        _c("div", { staticClass: "icon-footer icon-draft" }),
        _vm._v(" "),
        _c("div", { staticClass: "event-item-icon-amount" }, [
          _vm._v(_vm._s(_vm.client.drafts))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-item-icon-component row" }, [
      _c("div", { staticClass: "icon-footer icon-submitted" }),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-icon-amount" }, [
        _vm._v(" " + _vm._s(_vm.client.archived))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event-item-icon-component row" }, [
      _c("div", { staticClass: "icon-footer icon-approved" }),
      _vm._v(" "),
      _c("div", { staticClass: "event-item-icon-amount" }, [
        _vm._v(_vm._s(_vm.client.approved))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e54ec1b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e54ec1b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/ClientCardFooter.vue
// module id = 1587
// module chunks = 1